import React, { FunctionComponent, useState } from "react";
import styles from "./VideoEmbed.module.scss";
import VideoEmbedContent from "./VideoEmbed.interface";

import combineClasses from "helpers/combine-classes";
import IconViewer from "components/IconViewer/IconViewer";
import ReactPlayer from "react-player";

const VideoEmbed: FunctionComponent<VideoEmbedContent> = (props) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(props.autoplay ? true : false);

    const isPlayingClass = isPlaying === true ? `${styles.isPlaying}` : undefined;
    const isAutoplay = props.autoplay ? props.autoplay : false;
    const isLoop = props.loop ? props.loop : false;
    const isSoundButton = props.soundButton ? props.soundButton : false;

    const onPlayPause = () => {
        setIsPlaying(!isPlaying);
    };

    const onMuteToggle = () => {
        setIsMuted(!isMuted);
    };

    return (
        <div
            className={styles.wrapper}
            style={{ paddingTop: `${(props.heightRatio * 100).toFixed(2)}%` }}
        >
           
            {/* Media */}
            {props.src ? (
                <ReactPlayer
                    url={props.src}
                    className={styles.video}
                    loop={isLoop ? true : false}
                    muted={isMuted}
                    controls={isAutoplay ? false : true}
                    playing={isPlaying}
                    width={"100%"}
                    height={"100%"}
                    stopOnUnmount={false}
                    config={{
                        youtube: {
                            playerVars: {
                                autoplay: isAutoplay ? 1 : 0,
                                mute: isAutoplay ? 1 : 0, // Must mute to autoplay
                                color: "white",
                                controls: isAutoplay ? 0 : 1, // Hide controls on autoplay
                                rel: 0,
                                loop: isLoop ? 1 : 0,
                                playsinline: 1,
                                fs: 0,
                                modestbranding: 1,
                                showinfo: 0,
                                cc_load_policy: 3,
                                cc_lang_pref: "none",
                            },
                        },
                    }}
                />
            ) : null}

            {!isAutoplay && (
                <div
                    className={combineClasses([styles.button_wrapper, isPlayingClass])}
                    onClick={() => onPlayPause()}
                >
                    <button
                        type="button"
                        className={styles.button}
                    >
                        {!isPlaying ? (
                            <IconViewer
                                className={styles.icon}
                                name="play"
                            />
                        ) : (
                            <IconViewer
                                className={styles.icon}
                                name="pause"
                            />
                        )}
                    </button>
                </div>
            )}

            {isAutoplay && isSoundButton ? (
                <div
                    className={styles.button_wrapper}
                    onClick={onMuteToggle}
                >
                    <div className={styles.sound_button}>
                        {isMuted ? (
                            <IconViewer
                                className={styles.sound_icon}
                                name="sound-off"
                            />
                        ) : (
                            <IconViewer
                                className={styles.sound_icon}
                                name="sound-on"
                            />
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default VideoEmbed;
